import { ApiBitMask, ApiBitMaskTypes } from '../../../logger/bitMasks/ApiBitMask';
import { Fetcher } from '../../Fetcher';

import type { VersionsConfigType } from './types';

export interface FetchVersionsParams {
  url: string;
  game: string;
  JSESSIONID: string;
}

// Fetch backend version of a game
export const fetchVersions = ({ url, game, JSESSIONID }: FetchVersionsParams): Promise<VersionsConfigType> => {
  return Fetcher.fetch<VersionsConfigType>(url, {
    params: {
      game,
      JSESSIONID,
    },
  }).then<VersionsConfigType>((result) => {
    ApiBitMask.apply(ApiBitMaskTypes.Version);
    return result;
  });
};
